<template>
	<v-card class="pa-0 p-relative card-externo" outlined rounded="lg">
		<v-card class="ma-4 px-4 pt-1 pb-2 p-relative card-interno" outlined rounded="lg">

			<v-layout class="p-absolute justify-center ma-0 pa-0" style="top: 4px; right: 4px; z-index: 3;">
			<!-- Deletar	-->
				<v-tooltip v-if="item.cdCrecheSemLote > 0" top>
					<template v-slot:activator="{ on, attrs }">
						<!--            :disabled="programacaoAbateSelected.cdStatusProgramacaoAbate === 5"-->
						<v-btn
								v-bind="attrs"
								v-on="on"
								depressed
								icon
								x-small
								color="#ff5252"
								@click.native="preparaDelecao()"
								:disabled="deleting"
								class="mr-1 card-actions__btn delete"
						>
							<v-icon x-small color="white">fas fa-trash</v-icon>
						</v-btn>
					</template>
					<span>Remover</span>
				</v-tooltip>
			</v-layout>
			<v-container class="pt-0">
				<!-- Dados básicos -->
				<v-row class="d-flex flex-column pt-2">
					<span class="nome-produtor">{{ item.nmProdutor || item.nmEstabelecimento }}</span>
					<span style="height: 20px">
						<span class="label-info">Pavilhão </span><span class="value-info">{{ item.nrPavilhao | coalesce }}</span>
						<span class="label-info ml-2">UEP </span><span class="value-info">{{ item.nrUnidadeExploracao }}</span>
					</span>
				</v-row>

				<!-- nr Lote Controle -->
				<v-row class="d-flex flex-column pt-5">
          <span class="label-info">Nrº lote de controle</span>
					<span class="nr-lote-controle">{{ item.nrLoteControle | coalesce }}</span>
				</v-row>

				<!-- Idade e qt Animais -->
				<v-row class="pt-5">
					<v-col class="ma-0 pa-0 align-stretch" cols="7">
						<div class="label-info">Idade do lote</div>
						<div class="value-info-big">{{ item.nrDiasLote | coalesce }} {{ item.nrDiasLote ? 'dias' : '' }}</div>
					</v-col>
					<v-col class="ma-0 pa-0 align-stretch" cols="5">
						<div class="label-info">Animais</div>
						<div class="value-info-big">{{ item.qtAnimais | coalesce }}</div>
					</v-col>
				</v-row>
				<v-row class="pt-5">
					<v-col class="pa-0 mx-0 mr-1">
						<span :class="blSelecionado ? ' data__label__text' : 'label-info'" class="pt-0">Observação</span>
						<v-textarea no-resize dense outlined rows="2" counter="250" v-model="dsObservacao"
	                    	@change="validarObservacao()" :rules="[LIMITE_CARACTERES(250)]" />
					</v-col>
				</v-row>
			</v-container>
		</v-card>
		<!-- Seleção do lote -->
		<v-row class="pa-0 ma-4 d-flex flex-column">
			<div class="selecionar-lote d-flex align-center ma-0 px-6" @click="blSelecionado = !blSelecionado" v-ripple>
				<v-icon color="#0CA5A2" size="19" v-show="this.blSelecionado">fas fa-check-square</v-icon>
				<v-icon color="#0CA5A2" size="19" v-show="!this.blSelecionado">far fa-square</v-icon>
				<div class="selecionar-lote-texto ml-6">Selecionar</div>
			</div>
		</v-row>

		<!-- Estado card deletado		-->
			<v-fade-transition hide-on-leave>
				<v-overlay v-if="deleting" absolute>
					<v-row justify="center" align="center" class="ma-2">
						Confirmar exclusão?
					</v-row>
					<v-row justify="center" align="center" class="ma-2">
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn v-on="on" fab depressed color="#2BC1B6" small class="white--text"
								       @click="cancelarDelecao()">
									<v-icon small>fas fa-undo</v-icon>
								</v-btn>
							</template>
							<span>Desfazer</span>
						</v-tooltip>
					</v-row>
					<v-row justify="center" align="center" class="ma-2">
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn v-on="on" fab depressed color="#ff5252" small class="white--text"
								       @click="deletarCrecheSemLote()">
									<v-icon small>fas fa-trash</v-icon>
								</v-btn>
							</template>
							<span>Deletar</span>
						</v-tooltip>
					</v-row>
				</v-overlay>
			</v-fade-transition>
	</v-card>
</template>

<script>
import moment from "moment";
import {RULES} from "../../resources"

export default {
	name: "CrechesCard",
	data: () => ({
		tiposGenero: [
			{sgSexo: 'MA', dsSexo: 'Macho'},
			{sgSexo: 'FE', dsSexo: 'Fêmea'},
			{sgSexo: 'MI', dsSexo: 'Misto'}
		],
		deleting: false,
	}),
	computed: {
		blSelecionado: {
			get() {
				return this.item.blSelecionado
			},
			set(sel) {
				this.$emit('selecionarLote', sel)
			}
		},
		dsObservacao: {
			get() {
				return this.item.dsObservacao
			},
			set(value) {
				this.$emit('preencherObservacao', value)
			}
		},
	},
	methods: {
		...RULES,
		preparaDelecao() {
			this.deleting = true
		},
		cancelarDelecao() {
			this.deleting = false
		},
		deletarCrecheSemLote() {
			this.$axios.delete('/creche-sem-lote/' + this.item.cdCrecheSemLote)
					.then(res => {
						if (!res.data) return
						if (!res.data[0].data) return

						this.$emit('loteDeletado')
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error})
					})
					.finally(() => {
						this.deleting = false
					})
		},
		validarObservacao() {
			if (this.observacao.length > 250) this.observacao = this.observacao.substring(0, 250)
		},
	},
	filters: {
		coalesce(val){
			return !val ? '--' : val
		}
	},
	props: {
		item: {
			type: Object,
			required: true
		}
	}
}
</script>

<style scoped lang="scss">
.border-error {
  border: 0;
  box-shadow: inset 0 0 0 2px #FF5252;
}

.selecionar-lote {
  cursor: pointer;
  user-select: none;
  background-color: #87E2D129;
  border: 1px solid #33D6AB80;
  height: 42px;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
}

.selecionar-lote-texto {
  font: normal normal normal 16px/22px Roboto;
  letter-spacing: 0;
  color: #0CA5A2 !important;
  text-overflow: ellipsis;
	margin-top: 3px;
}

.label-value {
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0px;
  color: #7B9596;
}

.label-info {
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0;
  color: #12303C99;
}

.value-info {
  font: normal normal bold 12px/16px Roboto;
  letter-spacing: 0;
  color: #37565C;
}

.value-info-big {
  font: normal normal bold 15px/20px Roboto;
  letter-spacing: 0;
  color: #37565C;
}

.nome-produtor {
  font: normal normal bold 16px/21px Roboto;
  letter-spacing: 0;
  color: #10303DCC;
}

.tooltip {
  text-align: left;
  font: normal 12px Roboto;
  letter-spacing: 0;
  color: #e5e8e7;
}

.card-externo {
  background-color: #F2F5F3;
  border: solid #E5E8E7 1px;
}

.nr-lote-controle {
  font: normal normal bold 16px/18px Roboto;
  letter-spacing: 0;
  color: #10303DCC;
}
</style>